import React from 'react';
import { MagicButton, MagicButtonProps } from '../ai-assist/MagicButton';
import { TypeAIAssistTheme } from '../ai-assist/types';
import { APP_ENVIROMENT_TYPE } from '../configs/api/types';
import { AuthProvider, UserData } from '../provider/auth';
import { CovideoThemeProvider } from 'react-covideo-common';
interface Props extends MagicButtonProps {
  userData: UserData;
  token: string;
  aiAssistTheme: TypeAIAssistTheme;
  env?: APP_ENVIROMENT_TYPE;
  apiKey?: string;
}

export const CovideoMagicButton = ({ ...props }: Props) => {
  return (
    <AuthProvider
      userData={props.userData}
      token={props.token}
      env={props.env}
      apiKey={props.apiKey}
    >
      <CovideoThemeProvider themeName={props.aiAssistTheme}>
        <MagicButton
          userInput={props.userInput}
          defaultPromptType={props.defaultPromptType}
          handleSubmitGeneratedContent={props.handleSubmitGeneratedContent}
          margin={props.margin}
          hoverPopup={props.hoverPopup}
          hoverPosition={props.hoverPosition}
          videoId={props.videoId}
          defaultVin={props.defaultVin}
          handleOnCopySuccess={props.handleOnCopySuccess}
          defaultRecipient={props.defaultRecipient}
          defaultPromptUseCase={props.defaultPromptUseCase}
          variant={props.variant}
          iconColor={props.iconColor}
          size={props.size}
          disabled={props.disabled}
          text={props.text}
        />
      </CovideoThemeProvider>
    </AuthProvider>
  );
};
